import axios from "axios";

class Tag {
    get(id) {
        return axios.get(`/api/v1/tags/${id}`);
    }

    create(data = {}) {
        return axios.post(`/api/v1/tags`, data);
    }

    edit(id, data = {}) {
        return axios.put(`/api/v1/tags/${id}`, data);
    }

    delete(id) {
        return axios.delete(`/api/v1/tags/${id}`);
    }
}

export default Tag